











import Vue from "vue";
import ImgFooter from "@/components/ImgFooter.vue";
import TopNav from "@/components/TopNav.vue";
import MainMenu from "@/components/MainMenu.vue";

export default Vue.extend({
  name: "App",
  components: {
    TopNav,
    ImgFooter,
    MainMenu
  },
  data() {
    return {
      toggleMenu: true
    };
  }
});
